import React, { useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { FormattedMessage } from "react-intl";
import { Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const NewVersionNotice = ({ currentVersion }) => {
  useEffect(() => {
    let notifiedVersion;
    const interval = setInterval(() => {
      const randomNumber = Math.floor(Math.random() * 1000000);
      axios.get(`${process.env.PUBLIC_URL}/meta.json?v=${randomNumber}`).then(
        (res) => {
          const deployedVersion = res.data?.version;
          if (
            typeof deployedVersion === "string" &&
            deployedVersion !== currentVersion &&
            deployedVersion !== notifiedVersion
          ) {
            notifiedVersion = deployedVersion;
            toast.info(
              <div>
                <div className="d-flex align-items-center">
                  <FontAwesomeIcon
                    icon="circle-info"
                    className="me-3 flex-shrink-0"
                  />
                  <FormattedMessage id="NewVersionAvailable" />
                </div>
                <div className="d-flex justify-content-end mt-2">
                  <Button
                    size="sm"
                    color="light"
                    onClick={() => window.location.reload()}
                  >
                    <FormattedMessage id="Reload" />
                  </Button>
                </div>
              </div>,
              {
                toastId: "NewVersionAvailable",
                autoClose: false,
                closeOnClick: false,
                icon: false,
              },
            );
          }
        },
        () => {},
      );
    }, 600000);
    return () => clearInterval(interval);
  }, [currentVersion]);

  return null;
};

export default NewVersionNotice;
